import { setCookie as setCookieNext } from 'cookies-next'
import { deleteCookie as deleteCookieNext } from 'cookies-next'
import { getCookie as getCookieNext } from 'cookies-next'

// @ts-ignore - cookies-next is not typed
export const setCookie = (key: string, data?: unknown, opts?: unknown) => setCookieNext(key, data, opts)

// @ts-ignore - cookies-next is not typed
export const deleteCookie = (key: string, opts?: unknown) => deleteCookieNext(key, opts)

// @ts-ignore - cookies-next is not typed
export const getCookie = (key: string, opts?: unknown) => getCookieNext(key, opts)
